import helper from 'store/actions/actionHelper';
import authServicesExt from 'modules/auth/services/authServicesExt';

export const getVoucherInfo = (
  code: string,
  withoutError = false,
  actionOptions?: any
) => {
  return helper.dispatchAsyncAction(async () => {
    const response = await authServicesExt.getVoucherInfo(code, withoutError);

    return response;
  }, actionOptions);
};
